<template>
  <div class="am-pie-chart" ref="chartdiv" :style="`height: ${height};`"></div>
</template>
<script>
/* Imports */
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import am4themes_material from "@amcharts/amcharts4/themes/material";
am4core.useTheme(am4themes_animated);
am4core.useTheme(am4themes_material);

export default {
  name: "AmStackedClustered",
  props: {
    chartData: {},
    value: {},
    category: {},
    height: {
      type: String,
      default: "500px",
    },
    yTitle: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      isLoading: false,
      chart: {},
      report: [],
    };
  },
  watch: {
    chartData: function (_val) {
      this.report = _val;
    },
  },
  mounted() {
    this.report = this.chartData;
    var _this = this;
    this.$nextTick(() => {
      _this.renderChart();
    });
    this.$root.$on("bar:update", function (e) {
      _this.report = e;
      if (_this.chart) _this.chart.dispose();
      _this.renderChart();
      // vm.chart.validateData();
    });
  },
  methods: {
    renderChart() {
      var chart = am4core.create(this.$refs.chartdiv, am4charts.XYChart);
      // chart.scrollbarX = new am4core.Scrollbar();

      // Add data
      chart.rtl = true;
      chart.fontFamily = "iranyekan";
      chart.data = this.report;

      // Create axes
      var categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
      categoryAxis.dataFields.category = this.category;
      // categoryAxis.renderer.grid.template.location = 0;
      // categoryAxis.renderer.minGridDistance = 30;
      categoryAxis.renderer.labels.template.horizontalCenter = "center";
      categoryAxis.renderer.labels.template.verticalCenter = "middle";
      // categoryAxis.renderer.labels.template.rotation = 270;
      categoryAxis.tooltip.disabled = true;
      // categoryAxis.renderer.minHeight = 110;

      var valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
      valueAxis.renderer.minWidth = 50;
      valueAxis.title.text = this.yTitle;

      // Create series
      var series = chart.series.push(new am4charts.ColumnSeries());
      series.sequencedInterpolation = true;
      series.dataFields.valueY = this.value;
      series.dataFields.categoryX = this.category;
      series.tooltipText = "[{categoryX}: bold]{valueY}[/]";
      series.columns.template.strokeWidth = 0;

      series.tooltip.pointerOrientation = "vertical";

      series.columns.template.column.cornerRadiusTopLeft = 10;
      series.columns.template.column.cornerRadiusTopRight = 10;
      series.columns.template.column.fillOpacity = 0.8;

      // on hover, make corner radiuses bigger
      var hoverState = series.columns.template.column.states.create("hover");
      hoverState.properties.cornerRadiusTopLeft = 0;
      hoverState.properties.cornerRadiusTopRight = 0;
      hoverState.properties.fillOpacity = 0.6;

      series.columns.template.adapter.add("fill", function (fill, target) {
        return chart.colors.getIndex(target.dataItem.index);
      });

      // Cursor
      chart.cursor = new am4charts.XYCursor();
      this.chart = chart;
    },
  },
  beforeDestroy() {
    if (this.chart) {
      this.chart.dispose();
    }
    this.$root.$off("bar:update");
  },
};
</script>
<style scoped>
.am-pie-chart {
  width: 100%;
  height: 500px;
  direction: ltr !important;
  margin-top: 3%;
}
</style>